(function () {
  if (window.__collectionIconMenuInitialized) return;
  window.__collectionIconMenuInitialized = true;

  var SECTION_SELECTOR = '.collection-icon-menu';
  var DESKTOP_BREAKPOINT = 750;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initSection(section) {
    if (!section || section.dataset.collectionIconMenuInit === 'true') return;

    var scroller = section.querySelector('.collection-icon-menu__scroller');
    var scrollbar = section.querySelector('.collection-icon-menu__custom-scrollbar');
    var track = section.querySelector('.collection-icon-menu__custom-track');
    var thumb = section.querySelector('.collection-icon-menu__custom-thumb');

    if (!scroller || !scrollbar || !track || !thumb) return;
    section.dataset.collectionIconMenuInit = 'true';

    var rafId = null;
    var dragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var dragMoved = false;

    function updateThumb() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var trackWidth = track.clientWidth;
      var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

      if (!isDesktop || maxScroll <= 0 || trackWidth <= 0) {
        scrollbar.classList.add('is-hidden');
        return;
      }

      scrollbar.classList.remove('is-hidden');

      var proportionalThumbWidth = (scroller.clientWidth / scroller.scrollWidth) * trackWidth;
      var thumbWidth = Math.max(48, Math.min(trackWidth, proportionalThumbWidth));
      var maxThumbTravel = Math.max(0, trackWidth - thumbWidth);
      var thumbOffset = maxScroll > 0 ? (scroller.scrollLeft / maxScroll) * maxThumbTravel : 0;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + thumbOffset + 'px)';
    }

    function requestUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        updateThumb();
      });
    }

    function onTrackClick(event) {
      if (event.target === thumb || dragMoved) return;

      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var trackRect = track.getBoundingClientRect();
      var thumbWidth = thumb.offsetWidth;
      var relativeX = event.clientX - trackRect.left - thumbWidth / 2;
      var maxThumbTravel = trackRect.width - thumbWidth;

      if (maxScroll <= 0 || maxThumbTravel <= 0) return;

      var ratio = clamp(relativeX / maxThumbTravel, 0, 1);
      scroller.scrollTo({ left: ratio * maxScroll, behavior: 'smooth' });
    }

    function onPointerDown(event) {
      event.preventDefault();
      dragging = true;
      dragMoved = false;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
      thumb.classList.add('is-dragging');
      thumb.setPointerCapture(event.pointerId);
    }

    function onPointerMove(event) {
      if (!dragging) return;

      var deltaX = event.clientX - startX;
      if (Math.abs(deltaX) > 2) dragMoved = true;

      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var maxThumbTravel = track.clientWidth - thumb.offsetWidth;
      if (maxScroll <= 0 || maxThumbTravel <= 0) return;

      scroller.scrollLeft = startScrollLeft + (deltaX * maxScroll) / maxThumbTravel;
    }

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      thumb.classList.remove('is-dragging');
      try {
        thumb.releasePointerCapture(event.pointerId);
      } catch (e) {
      }
    }

    function onThumbClick(event) {
      if (!dragMoved) return;
      event.preventDefault();
      event.stopPropagation();
      dragMoved = false;
    }

    scroller.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    track.addEventListener('click', onTrackClick);
    thumb.addEventListener('pointerdown', onPointerDown);
    thumb.addEventListener('pointermove', onPointerMove);
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);
    thumb.addEventListener('lostpointercapture', endDrag);
    thumb.addEventListener('click', onThumbClick);

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(scroller);
      resizeObserver.observe(track);
    }

    updateThumb();
  }

  function initAllWithin(root) {
    if (!root) return;
    if (root.matches && root.matches(SECTION_SELECTOR)) {
      initSection(root);
    }
    if (!root.querySelectorAll) return;
    var sections = root.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllWithin(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllWithin(event.target);
  });

  initAllWithin(document);
})();
